
export const latestNews = [
  {
    id: 1,
    title: "Kanoon Receives Community Excellence Award",
    date: "March 10, 2024",
    excerpt: "We are honored to receive the Atlanta Community Excellence Award for our contributions to cultural diversity and community engagement.",
    image: "https://public.readdy.ai/ai/img_res/b6fa5104862339dead3420f0e11e24cd.jpg",
    category: "Awards"
  },
  {
    id: 2,
    title: "New Persian Art Exhibition Opens",
    date: "March 5, 2024",
    excerpt: "Discover the works of contemporary Persian artists in our new exhibition 'Bridges of Culture' running through April.",
    image: "https://readdy.ai/api/search-image?query=Persian%20art%20exhibition%20in%20gallery%20with%20contemporary%20paintings%20and%20sculptures%2C%20visitors%20viewing%20artwork%2C%20modern%20gallery%20lighting%2C%20Persian%20cultural%20themes%20in%20art%2C%20elegant%20display&width=400&height=250&seq=artexhibit2024&orientation=landscape",
    category: "Arts"
  },
  {
    id: 3,
    title: "Youth Program Expansion Announced",
    date: "February 28, 2024",
    excerpt: "We're expanding our youth programs to include more cultural activities, language classes, and leadership development opportunities.",
    image: "https://readdy.ai/api/search-image?query=Persian%20youth%20program%20with%20teenagers%20participating%20in%20cultural%20activities%2C%20learning%20traditional%20dance%20and%20music%2C%20bright%20classroom%20environment%2C%20engaged%20young%20people%2C%20educational%20setting&width=400&height=250&seq=youth2024&orientation=landscape",
    category: "Programs"
  },
  {
    id: 4,
    title: "Successful Fundraising Gala",
    date: "February 20, 2024",
    excerpt: "Thank you to all who attended our annual fundraising gala. Together we raised $50,000 for community programs.",
    image: "https://readdy.ai/api/search-image?query=Elegant%20fundraising%20gala%20event%20with%20people%20in%20formal%20attire%2C%20Persian%20cultural%20decorations%2C%20dining%20tables%2C%20stage%20with%20speakers%2C%20successful%20charity%20event%20atmosphere&width=400&height=250&seq=gala2024&orientation=landscape",
    category: "Fundraising"
  }
];
